import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	popularity: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	popularity: {
		id: 'directories.common.components.popularity-cell.popularity',
		defaultMessage: '{popularity, plural, one {{popularity} person} other {{popularity} people}}',

		description: 'Displaying entity popularity (favorites count)',
	},
});
export default messages;
